// Generated by scripts/build-icons.js from the installed Font Awesome icon packs.
// Do not edit by hand.
import type { FaIcon } from 'shared/components/icon';

export const falAngleRight = {"name":"angle-right","type":"fal","definition":[256,512,"angle-right","M235.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256 52.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"]} as const satisfies FaIcon;
